import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { SingleCheckout } from './pages/Checkout/Single';
import { RecurringCheckout } from './pages/Checkout/Recurring';
import { RecurringPixCheckout } from './pages/Checkout/RecurringPix';
import { CreateCreditCard } from './pages/CreateCreditCard';
import { Chat } from './pages/Chat';
import { Unavailable } from './pages/Checkout/Unavailable';
import { ThanksPage } from './pages/Checkout/Thanks';
import { UpsellPage } from './pages/Checkout/Upsell';
import { PricingPageView } from './pages/Checkout/PricingPage';
import { UpdateSubscriptionCard } from './pages/UpdateSubscriptionCard';

export const Router = () => {
	return (
		<BrowserRouter>
			<Routes>
				<Route path="/unavailable" element={<Unavailable />} />
				<Route path="/planos/:slug" element={<PricingPageView />} />
				<Route
					path="/:platform/planos/:slug"
					element={<PricingPageView />}
				/>
				<Route path="/p/thanks/:slug" element={<ThanksPage />} />
				<Route
					path="/:platform/p/thanks/:slug"
					element={<ThanksPage />}
				/>
				<Route path="/p/upsell/:slug" element={<UpsellPage />} />
				<Route
					path="/:platform/p/upsell/:slug"
					element={<UpsellPage />}
				/>
				<Route
					path="/p/downsell/:slug"
					element={<UpsellPage variant="downsell" />}
				/>
				<Route
					path="/:platform/p/downsell/:slug"
					element={<UpsellPage variant="downsell" />}
				/>
				<Route path="/p/:slug" element={<SingleCheckout />} />
				<Route path="/:platform/p/:slug" element={<SingleCheckout />} />
				<Route
					path="/p/recurring/:reference"
					element={<RecurringCheckout />}
				/>
				<Route
					path="/:platform/p/recurring/:reference"
					element={<RecurringCheckout />}
				/>
				<Route
					path="/p/recurring/pix/:reference"
					element={<RecurringPixCheckout />}
				/>
				<Route
					path="/:platform/p/recurring/pix/:reference"
					element={<RecurringPixCheckout />}
				/>
				<Route
					path="/credit-cards/create"
					element={<CreateCreditCard />}
				/>
				<Route
					path="/cp/subscriptions/:subscriptionCode/card"
					element={<UpdateSubscriptionCard />}
				/>
				<Route path="/chat" element={<Chat />} />
			</Routes>
		</BrowserRouter>
	);
};
